import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { size as _size } from 'lodash';
import { i18nIntl, removeByRole, importCSS, getRemotedbUrl } from '../../lib/ep.js';
import { sweep as const_sweep } from './bootstrap';

import ActionButton, { SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import DisabledArea from '../builder/DisabledArea';
import FloatingLayer from '../builder/FloatingLayer';
import SaveButton from '../builder/SaveButton';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import Spinner from '../builder/Spinner';
import ToggleButton from '../builder/ToggleButton';
import TextArea from '../builder/TextArea';
import Tooltip from '../builder/Tooltip';
import Message from '../builder/Message';

import InfiniteScroll from '../hoc/InfiniteScroll';

import UserName from '../front/UserName';
import RibbonCollection from '../ui_items/RibbonCollection.js';

class SweepParticipantsLayer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			loaded:false,
			loading:false,
			display_participants_images:false,
			reply_message:false,
			reply_message_result:{},
			has_gallery:false,
			participants:props.participants,
			participants_photo:props?.participants_photo ?? [],
			is_gallery_loaded:false,
			action_exclude_no_photo:'add',
			making_exclusion_nophoto:false,
		}
		this.timeout_excluding;
	}

	componentWillMount() {
		importCSS('comp/sweeps.css');
	}

	componentDidMount() {
		this.fetchParticipants(1, (d) => this.fetched(d.data));
		this.setState({...this.state});
		const sweep_label = this.props.sweep.label != undefined ? this.props.sweep.label[0] : {};
		if(_size(sweep_label)>0)removeByRole(sweep_label,this.props.roles);
	}

	componentDidUpdate() {
		const sweep_label = this.props.sweep.label != undefined ? this.props.sweep.label[0] : {};
		if(_size(sweep_label)>0)removeByRole(sweep_label,this.props.roles);
	}


	fetched(data) {
		this.state.participants=this.state.participants.concat(data);
		this.state.participants_photo = [];
		this.state.participants.map((item, i) => {
			if(item.photo_w && item.photo_h) {
				this.state.participants_photo.push(item);
				return;
			}
		});

		if(this.props.display_participants_images) this.calculateGallery(200);
		this.state.loaded = true;
		this.state.loading = false;
		this.setState({...this.state});
	}

	fetchParticipants(page, cb) {
		var d = {};
		if(page) d.p = page
			//d.remotedb=1;
		this.setState({loading:true});
		$.get(getRemotedbUrl('/sweeps/fetch_participants/'+this.props.sweep.id), d, (result) => {
			if(result.photo_viewer != undefined && !this.state.has_gallery) this.state.has_gallery = true

			var has_more = false;
			if(result.elements != undefined) {
				has_more = (this.state.participants.length + result.elements.length < this.props.sweep.total_participants) ? true : false;
			}
			if(result.elements!=undefined){
				if((this.state.participants.length + result.elements.length + 1) > this.props.limit_show){
					has_more = false;
				}
			}else{
				result.elements = [];
				has_more = false;
			}
			if(cb) cb({ data:result.elements, hasMore:has_more });
		}, 'JSON');
	}

	blacklist(participant) {
		if(window.blacklist[participant.fbuid] != undefined) {
			delete window.blacklist[participant.fbuid];
		} else {
			window.blacklist[participant.fbuid] = participant.network;

			for(var i in window.suggestions){
				if(window.suggestions[i].fbuid === participant.fbuid && participant.page.id == window.suggestions[i].page.id){
					window.suggestions.splice(i,1);
					break;
				}
			}
		}

		this.setState({...this.state});

		$.post('/sweeps/action_blacklist/'+participant.network, participant);
	}

	excludeUsersNoPhoto(participant) {
		this.state.making_exclusion_nophoto = true;
		this.setState({...this.state});
		$.post("/sweeps/exclude_actions_participants/" + this.props.sweep.id, { type:'nophoto', action:this.state.action_exclude_no_photo }, function(result) {
			//this.props.stateStatus(result);
			if(result.excludeds != undefined) {
				this.props.sweep.config.exclude = result.excludeds;
				this.state.action_exclude_no_photo = (this.state.action_exclude_no_photo == 'add') ? 'delete' : 'add';
				this.state.making_exclusion_nophoto = false;
				if(this.props.savejs != undefined) this.props.savejs(this.props.sweep);
			}

			// we delayed the action a bit (0.5 sec) to make it more explicit for short processing times:
			setTimeout(function() {
				this.setState({...this.state});
			}.bind(this), 500);
		}.bind(this), 'json');
	}

	toggleGallery() {
		this.state.display_participants_images = !this.state.display_participants_images;
		if(this.state.display_participants_images) {
			this.calculateGallery(200);
		}
		this.setState({...this.state});
	}

	exclude(participant) {
		clearTimeout(this.timeout_excluding);
		var sweep = this.props.sweep;
		var net_id = sweep.network==const_sweep.ID_LIST ? participant.id : participant.fbuid;
		var already_excluded = false;
		if(sweep.config.exclude != undefined) {

			if(typeof sweep.config.exclude == "object"){
				var exclude_tmp = [];
				$.each(sweep.config.exclude, function(j,jtem){
					exclude_tmp.push(jtem);
				});
				sweep.config.exclude = exclude_tmp;
			}

			sweep.config.exclude.map((item, i) => {
				if(item != undefined && item.net_id == net_id) {
					already_excluded = true;
					sweep.config.exclude.splice(i,1);
					return;
				}
			});
		} else {
			sweep.config.exclude = [];//Not created, initialize
		}
		if(!already_excluded) {
			sweep.config.exclude.push({net_id:net_id,name:participant.name,network:participant.network});
		}
		this.setState({...this.state});
		this.timeout_excluding = setTimeout(()=>{
			if(this.props.save!=undefined)this.props.save();
			if(this.props.savejs!=undefined)this.props.savejs(sweep);
		},2000)

	}

	calculateGallery(max_row_height) {
		this.state.is_gallery_loaded = false;
		this.setState({...this.state});

		var t = setTimeout(function() {
			const item_paddings = 34;

			// 15px for scrollbar + 10px for paddingRight value (which is really 0 but we emulate it with code)
			const total_width = $('.gui_bricked_gallery').width() - 15 - 10;

			// we calc the images sizes related to max_row_height
			this.state.participants_photo.map((item, i) => {
				this.state.participants_photo[i].width = max_row_height * item.photo_w / item.photo_h;
				this.state.participants_photo[i].height = max_row_height;
			});
			this.setState({...this.state});

			// we distribute the images in rows (regarding if they fit + threshold)
			const threshold = total_width * 0.2; // additional 20%
			var row = 0;
			var width_tmp = 0;
			var items_in_row = [];
			this.state.participants_photo.map((item, i) => {
				width_tmp = parseFloat(width_tmp) + parseFloat(item.width) + item_paddings;

				this.state.participants_photo[i].row = row;

				if(items_in_row[row] == undefined) items_in_row[row] = 0;
				items_in_row[row]++;

				if(width_tmp > total_width + threshold) {
					row++;
					width_tmp = 0;
				}
			});

			var rows_width = [];
			this.state.participants_photo.map((item, i) => {
				if(rows_width[item.row] == undefined) rows_width[item.row] = 0;
				rows_width[item.row] = parseFloat(rows_width[item.row]) + parseFloat(item.width);
			});

			var prop = 1;
			this.state.participants_photo.map((item, i) => {
				if(rows_width[item.row] > total_width) {
					prop = (total_width - item_paddings * (items_in_row[item.row] - 1)) / rows_width[item.row];
				}
				this.state.participants_photo[i].calc_width = item.width * prop;
				this.state.participants_photo[i].calc_height = max_row_height * prop;
			});

			this.state.is_gallery_loaded = true;

			this.setState({...this.state});
		}.bind(this), 1000);
	}

	changeReplyMessage(k, v) {
		if(this.state.reply_message[k] == undefined) this.state.reply_message[k] = '';
		v = v.replace(/(https?:\/\/(www\.)|ftps?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/g, '');
		this.state.reply_message[k] = v;
		this.setState({...this.state});
	}

	sendReplyMessage(cb) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		$.post(getRemotedbUrl('/sweeps/send_reply_message/' + this.props.sweep.id), { user:this.state.reply_message }, function(result) {
			// we delayed the action a bit (0.5 sec) to make it more explicit for short processing times:
			this.state.reply_message_result.status = result.status;
			this.state.reply_message_result.message = result.status ? i18n("Your message has been successfully sent") : i18n("Error sending message");
			//this.state.reply_message = false;
			var t = setTimeout(() => {
				this.setState({...this.state});
				if(cb!=undefined)cb();
			}, 500);

		}.bind(this), 'json');
	}


	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const intl = this.props.intl;
		const sweep = this.props.sweep;
		const blacklist_disabled = (this.props.blacklist_disabled != undefined) ? this.props.blacklist_disabled : false;

		var blacklists = [];

		$.each(window.blacklist, function(i,item){
			blacklists[i]=item;
		});
		var excludeds = [];
		if(sweep.config.exclude!=undefined){
			$.each(sweep.config.exclude,function(i,item){
				if(item != undefined) excludeds[item.net_id]=1;
			});
		}

		var participants = [];
		$.each(this.state.participants,function(i, item) {
			participants.push(item);
		});

		var participants_photo = [];
		$.each(this.state.participants_photo, function(i, item) {
			participants_photo.push(item);
		});

		var show_fb = false;
		var show_ig = false;
		var show_tw = false;
		var show_yt = false;
		if(sweep.network == const_sweep.ID_FACEBOOK) show_fb = true;
		if(sweep.network == const_sweep.ID_INSTAGRAM) show_ig = true;
		if(sweep.network == const_sweep.ID_TWITTER) show_tw = true;
		if(sweep.network == const_sweep.ID_YOUTUBE) show_yt = true;

		var show_participations,show_email_live, main_field, visual_field = false;
		if(sweep.network == const_sweep.ID_LIST) {
			main_field = (sweep.config.main_field != undefined) ? sweep.config.main_field : -1;
			visual_field = (sweep.config.visualization_field != undefined) ? sweep.config.visualization_field : -1;
			show_participations = (main_field >= 0 && visual_field >= 0 && main_field != visual_field) ? true : false;

			if(sweep.type == const_sweep.TYPE_LIVE) {
				if(sweep.config.form.email_request != undefined)show_email_live = true;

			}
		}

		if(this.state.reply_message){
			const user_to_reply = this.state.reply_message;
			const reply_response = this.state.reply_message_result;
			return (
				<FloatingLayer backButton={() => this.setState({reply_message:false,reply_message_result:{}})} _class={{size:'small'}}>
					<div>
						<SectionTitle><FormattedMessage id="Reply message to {user}"  values={{user:`@${user_to_reply.username}`}}/></SectionTitle>
						{(sweep.type == const_sweep.TYPE_STORY_REPLYTO) && (
							<SectionSubtitle autotranslate={false}>{i18n("Original message")+': '+user_to_reply.full_comment}</SectionSubtitle>
						)}
						<TextArea
							name="message"
							label_props={{
								tooltip:<Tooltip>Write @username to place the mention</Tooltip>,
							}}
							max_length={100}
							model={user_to_reply}
							change={(k, v) => this.changeReplyMessage(k, v)}
							placeholder={i18n("Write here your reply message")}
						>Message</TextArea>

						{(reply_response.status != undefined) && (
							<Message
								type={(reply_response.status == '1') ? 'success' : 'alert'}
								title={reply_response.message}
								icon={(reply_response.status == '1') ? 'knk-ok' : 'knk-alert'}
								_class={{ other:'in_bottom' }}
							/>
						)}

						<ButtonCollection in_floating={true}>
							{(reply_response.status == undefined) && (
								<SaveButton
									icon='knk-send'
									onClick={(e,cb) => this.sendReplyMessage(cb)}
								>Send</SaveButton>
							)}
							<SecondaryButton
								onClick={()=>this.setState({reply_message:false,reply_message_result:{}})}
								_class={{icon:reply_response.status == undefined ? 'knk-go-prev' : false}}
								autotranslate={false}
							>{reply_response.status == undefined ? i18n("Go back") : i18n("Close")}</SecondaryButton>

						</ButtonCollection>
					</div>
				</FloatingLayer>
			)
		}

		return (
			<FloatingLayer backButton={() => this.props.back()} _class={{size:'fullscreen'}}>
				<div class="without_actions">
					<div class="gui_section_header alone_section_header cleared_header" id="width_participants">
						<SectionTitle autotranslate={false}>{(!this.state.display_participants_images) ? i18n("List of participants") : i18n("Photo Gallery")}</SectionTitle>
						<ButtonCollection>
							{(this.state.has_gallery && sweep.status != const_sweep.CLOSED && false) && (//Problemes serius,sobrecarrega del config pk nexclouen masses
								<div class="gui_pos_rel gui_not_in_end">
									<ActionLink
										onClick={() => this.excludeUsersNoPhoto()}
										icon={(this.state.action_exclude_no_photo == 'add') ? 'knk-off' : 'knk-on'}
										autotranslate={false}
									>{(this.state.action_exclude_no_photo == 'add') ? i18n("Exclude comments without photo") : i18n("Undo")}</ActionLink>

									{(this.state.making_exclusion_nophoto) && (
										<Spinner force_bg={true} _class={{h_position:'right'}} />
									)}
								</div>
							)}

							<ActionButton
								onClick={() => this.props.toggleDownloadOptions()}
								icon='knk-download'
							>Export</ActionButton>

							{(this.state.has_gallery && !this.state.display_participants_images && sweep.network !== const_sweep.ID_FACEBOOK) && (//Image more than 255 characters , out on 22/06/2022
								<SecondaryButton
									onClick={() => this.toggleGallery()}
									icon='knk-picture'
								>Photo Gallery</SecondaryButton>
							)}

							{(this.state.display_participants_images && sweep.network !== const_sweep.ID_FACEBOOK) && (//Image more than 255 characters , out on 22/06/2022
								<SecondaryButton
									onClick={() => this.toggleGallery()}
									icon='knk-users'
								>List of participants</SecondaryButton>
							)}
						</ButtonCollection>
					</div>

					<div class="turn_to_landscape only_in_portrait max_width_500">
						<div class="knk-landscape-mode">
							<SectionSubtitle autotranslate={false}>{i18n("This content doesn't fit in portrait mode.")} {i18n("Please, turn your device to landscape mode.")}</SectionSubtitle>
						</div>
					</div>

					<div class="gui_pos_rel">
						<InfiniteScroll fetch={(p, cb) => this.fetchParticipants(p,cb)} fetched={this.fetched.bind(this)}  _maxHeight={{maxHeight:'calc(100dvh - 190px)'}}>
							{(!this.state.loaded || this.state.loading) && (
								<div class="is_loading_contents">
									<Spinner force_bg={true}>Loading participants</Spinner>
								</div>
							)}

							{(!this.state.display_participants_images && this.state.loaded) && (
								<table class="only_in_landscape max_width_500 gui_list_table" style={{width:'100%'}} cellSpacing="0" cellPadding="0">
									<thead>
										<tr class="list_header">
											<th />

											<th>{i18n("***Name")}</th>

											{(sweep.type != const_sweep.TYPE_LIKE && sweep.network != const_sweep.ID_LIST) && (
												<th>{i18n("Created on")}</th>
											)}
											{show_participations && (
												<th class="gui_text_align_center">{i18n("Main field")}</th>
											)}
											{show_email_live && (
												<th class="gui_text_align_center">{i18n("Email")}</th>
											)}
											{sweep.network == const_sweep.ID_LIST && (
												<th class="gui_text_align_center">{i18n("Participations")}</th>
											)}

											{(sweep.type == const_sweep.TYPE_COMMENT || sweep.type == const_sweep.TYPE_HASHTAG || sweep.type == const_sweep.TYPE_STORY_REPLYTO) && (
												<th colspan={sweep.type != const_sweep.TYPE_STORY_REPLYTO ? 1 : 2}>{sweep.type == const_sweep.TYPE_STORY_REPLYTO ? i18n("Message") : i18n("Comments")}</th>
											)}

											{(sweep.type == const_sweep.TYPE_STORY_MENTION) && (
												<th />
											)}

											{(!show_fb && (sweep.type == const_sweep.TYPE_COMMENT || sweep.type == const_sweep.TYPE_HASHTAG)) && (
												<th class="social_data is_centered gui_text_align_center">{i18n("Mentions")}</th>
											)}

											{(sweep.status == const_sweep.OPENED && sweep.type != const_sweep.TYPE_LIVE) && (
												<th class="not_analyst not_designer gui_text_align_center">{i18n("Excluded")}</th>
											)}

											{(sweep.network != const_sweep.ID_LIST || (sweep.config.email_field != undefined && sweep.config.email_field >= 0)) && (
												<th class="not_analyst not_designer gui_text_align_center">{i18n("Blacklisted")}</th>
											)}
										</tr>
									</thead>

									<tbody>
										{participants.map((participant, i) =>  {
											var is_creator = (participant.iscreator) ? true : false;
											var net_id = sweep.network==const_sweep.ID_LIST ? participant.id : participant.fbuid;
											
											var is_excluded = (is_creator) ? true : ((excludeds[net_id] != undefined) ? true : false);
											var is_blacklist = blacklists[participant.fbuid] == participant.network;
											var link = (participant.link_to_post != undefined) ? participant.link_to_post : false;

											const icon_story = 'knk-story';
											const tooltip_story = sweep.type == const_sweep.TYPE_STORY_REPLYTO ? i18n("View replied story") : i18n("View story");

											const display_extra_info_username = ((sweep.type == const_sweep.TYPE_COMMENT || sweep.type == const_sweep.TYPE_HASHTAG) && (participant.promoted || participant.colaborator)) ? true : false;

											return (
												<tr key={i} class={((is_blacklist) ? 'gui_blacklisted_user' : ((is_excluded) ? 'gui_excluded_user' : null))}>
													<td>{i+1}</td>

													<td>
														<div class="gui_flexbox gui_flex_row gui_flex_nowrap gui_flex_align_center">
															{(sweep.network == const_sweep.ID_MULTI) && (
																<div class="gui_not_in_end_small" style={{ width:'var(--squared-button-size)' }}>
																	<SquaredButton
																		color="black"
																		icon={`ep-${participant.network}`}
																		_class={{other:'gui_withoutEvents'}}
																		aria-label="Participant network"
																	/>
																</div>
															)}

															{(participant.class_reaction) && (
																<UserName
																	linked={link}
																	link={link}
																	user={participant}
																	multiline={true}
																	is_builder={true}
																	extra_class={participant.class_reaction}
																/>
															)}

															{(sweep.type != const_sweep.TYPE_LIKE) && (
																<UserName
																	linked={link}
																	link={link}
																	user={participant}
																	multiline={true}
																	is_builder={true}
																	extra={(display_extra_info_username) ? (
																		<RibbonCollection
																			items={[{
																				title:"Promoted",
																				color:'main',
																				enabled:participant?.promoted ?? false,
																			}, {
																				title:"Collaborator",
																				tooltip:<Tooltip
																						autotranslate={false}
																						with_icon={false}
																						position='top'
																					>{participant.colaborator}</Tooltip>,
																				enabled:participant?.colaborator ?? false,
																			}]}
																		/>
																	) : null}
																/>
															)}
														</div>
													</td>

													{(sweep.type != const_sweep.TYPE_LIKE && sweep.network != const_sweep.ID_LIST) && (
														<td>
															<div class="gui_flexbox gui_flex_nowrap" style={{whiteSpace:'nowrap'}}>{participant.created}</div>
														</td>
													)}

													{(show_participations) && (
														<th class="gui_flex_align_left">{participant.config.data[main_field]}</th>
													)}

													{(show_email_live) && (
														<th class="gui_flex_align_left">{participant.fbuid}</th>
													)}

													{(sweep.network == const_sweep.ID_LIST) && (
														<th>{participant.entries}</th>
													)}

													{(sweep.type == const_sweep.TYPE_COMMENT || sweep.type == const_sweep.TYPE_HASHTAG) && (
														<td class="gui_pos_rel" style={{minWidth:'200px'}}>
															<div style={{maxHeight:'90px', overflow:'auto', lineHeight:'1.2em', padding:'0.2em 0'}}>{participant.full_comment}</div>
														</td>
													)}

													{(sweep.type == const_sweep.TYPE_STORY_MENTION || sweep.type == const_sweep.TYPE_STORY_REPLYTO) && (
														<>
															{(sweep.type == const_sweep.TYPE_STORY_REPLYTO) && (
																<td class="gui_pos_rel" style={{minWidth:'200px',maxWidth:'400px'}}>
																	<div style={{maxHeight:'90px', overflow:'auto', lineHeight:'1.2em', padding:'0.2em 0'}}>{participant.full_comment}</div>
																</td>
															)}

															<td class="gui_pos_rel">
																<ButtonCollection _class={{ other:'gui_flex_col gui_flex_align_top' }}>
																	{(participant.story) && (
																		<ActionLink
																			_href={participant.story}
																			_target="_blank"
																			icon={`${icon_story} gui_small_icon`}
																			tooltip={
																				(participant.expired_story) ? (
																					<Tooltip
																						icon="knk-alert redIcon gui_small_icon"
																						position="top"
																					>This story may not be available because it was posted more than 24 hours ago.</Tooltip>
																				) : false}
																		>{tooltip_story}</ActionLink>
																	)}

																	<ActionLink
																		onClick={() => this.setState({reply_message:participant})}
																		icon={`ep-invite gui_small_icon`}
																	>Reply message</ActionLink>
																</ButtonCollection>
															</td>
														</>
													)}

													{(!show_fb && (sweep.type == const_sweep.TYPE_COMMENT || sweep.type == const_sweep.TYPE_HASHTAG)) && (
														<td class="gui_text_align_center">{participant.mentions!=undefined ? participant.mentions : 0 }</td>
													)}

													{(sweep.status == const_sweep.OPENED && sweep.type != const_sweep.TYPE_LIVE) && (
														<td class="actions gui_text_align_center not_analyst not_designer">
															<ButtonCollection _class={{ other:'gui_flex_center' }}>
																<ToggleButton
																	squared={true}
																	tooltip={<Tooltip with_icon={false} position="top">{(is_creator) ? "Sweepstakes creator" : ((is_excluded) ? "Include again to sweep" : "Exclude from the sweepstakes")}</Tooltip>}
																	active={(is_creator || is_excluded) ? true : false}
																	icon='knk-checkbox-on'
																	icon_off='knk-checkbox-off'
																	color={false}
																	_class={{first:true, other:'main_text_color_icon'}}
																	disabled={is_creator}
																	onClick={() => this.exclude(participant)}
																/>
															</ButtonCollection>
														</td>
													)}

													{(sweep.network != const_sweep.ID_LIST || (sweep.config.email_field!=undefined && sweep.config.email_field>=0)) && (
														<td class="actions gui_text_align_center not_analyst not_designer">
															<ButtonCollection _class={{ other:'gui_flex_center' }}>
																{(participant.blacklist != 'none') && (
																	<ToggleButton
																		squared={true}
																		disabled={blacklist_disabled}
																		tooltip={<Tooltip with_icon={false} position="top">{((!blacklist_disabled) ? ((is_blacklist) ? "Remove from blacklist" : "Add to blacklist") : ((is_blacklist) ? "User in blacklist" : null))}</Tooltip>}
																		active={(is_blacklist) ? true : false}
																		icon='knk-checkbox-on'
																		icon_off='knk-checkbox-off'
																		color={false}
																		_class={{first:true, other:'main_text_color_icon'}}
																		onClick={() => this.blacklist(participant)}
																	/>
																)}

																{(participant.blacklist == 'none') && (
																	<ToggleButton
																		squared={true}
																		disabled={true}
																		tooltip={<Tooltip with_icon={false} position="top">No information to add to Blacklist</Tooltip>}
																		active={(is_blacklist) ? true : false}
																		icon='knk-checkbox-on'
																		icon_off='knk-checkbox-off'
																		color={false}
																		_class={{first:true, other:'main_text_color_icon '}}
																	/>
																)}
															</ButtonCollection>
														</td>
													)}
												</tr>
											)}
										)}
									</tbody>
								</table>
							)}

							{(this.state.display_participants_images && this.state.loaded) && (
								<ul class="gui_bricked_gallery">
									{!this.state.is_gallery_loaded && (
										<li class="is_loading_contents">
											<Spinner>Generating gallery</Spinner>
										</li>
									)}

									{this.state.is_gallery_loaded && participants_photo.map((participant, i) => {
										if(participant.photo) {
											//calculating Gallery
											var sizes_img = {}
											sizes_img.width = participant.calc_width + 'px';
											sizes_img.height = participant.calc_height + 'px';

											/*var userAvatar = {};
											if(participant.network != const_sweep.ID_INSTAGRAM) userAvatar.user_net_id = participant.id;
											if(participant.image != '') userAvatar.fixed_avatar = participant.image;
											userAvatar.network = participant.network;*/

											const is_creator = (participant.iscreator) ? true : false;
											const is_excluded = (is_creator) ? true : ((excludeds[participant.fbuid] != undefined) ? true : false);
											const tooltip_excluded = is_creator ? i18n("Sweepstakes creator") : (is_excluded ? i18n("Include again to sweep") : i18n("Exclude from the sweepstakes"));
											const is_blacklist = (blacklists[participant.fbuid] == participant.network) ? true : false;
											const tooltip_blacklist = !blacklist_disabled ? (is_blacklist ? i18n("Remove from blacklist") : i18n("Add to blacklist")) : (is_blacklist ? i18n("User in blacklist") : null);

											const icon_excluded = (is_excluded && !is_creator) ? 'knk-off' : ((is_creator) ? 'knk-blacklist' : 'knk-on');
											const other_excluded = (is_excluded && !is_creator) ? 'blackIcon' : ((is_creator) ? 'disabledItem blackIcon' : 'whiteIcon');

											const media = (participant.gif && sweep.network !== const_sweep.ID_TWITTER) ? participant.gif : participant.photo;

											return (
												<li key={i}>
													<DisabledArea disabled={((is_excluded || is_blacklist || is_creator) ? true : false)} message={tooltip_excluded}>
														<div class="is_media gui_pos_rel" style={{backgroundImage:'url('+media+')'}}>
															<img src={window.cdn_url + 'img/blank.png'} style={sizes_img} />
														</div>
													</DisabledArea>

													<div class="is_info">
														<ButtonCollection>
															{(participant.photo && !participant.gif) && (
																<SquaredButton
																	icon='knk-picture'
																	_class={{ other:'gui_withoutEvents'}}
																/>
															)}

															{(participant.gif) && (
																<SquaredButton
																	icon='knk-animated-gif'
																	_class={{ other:'gui_withoutEvents' }}
																/>
															)}

															{(participant.video) && (
																<SquaredButton
																	icon='knk-video'
																	_class={{ other:'gui_withoutEvents' }}
																/>
															)}

															{(sweep.status == const_sweep.OPENED) && (
																<ToggleButton
																	squared={true}
																	tooltip={<Tooltip with_icon={false} autotranslate={false}>{tooltip_excluded}</Tooltip>}
																	active={(is_excluded) ? true : false}
																	icon='knk-remove-user whiteIcon blueBg'
																	icon_off='knk-remove-user'
																	_class={{ other:'not_analyst not_designer' }}
																	onClick={() => this.exclude(participant)}
																	aria-label="Excluded participant"
																/>
															)}

															<div class="gui_pos_rel not_analyst not_designer">
																<ToggleButton
																	squared={true}
																	disabled={blacklist_disabled}
																	tooltip={<Tooltip with_icon={false} autotranslate={false}>{tooltip_blacklist}</Tooltip>}
																	active={(is_blacklist) ? true : false}
																	icon='knk-blacklist whiteIcon blueBg'
																	icon_off='knk-blacklist'
																	onClick={() => this.blacklist(participant)}
																	aria-label="Blacklisted participant"
																/>
															</div>
														</ButtonCollection>
													</div>
												</li>
											)
										}
									})}
								</ul>
							)}
						</InfiniteScroll>
					</div>
				</div>
			</FloatingLayer>
		);
	}
}

export default injectIntl(SweepParticipantsLayer);